import React, { useRef } from 'react';
import Popper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Popper';
import ClickAwayListener from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ClickAwayListener';
import {
  FDPaper,
  FDSecondaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('FilterControl', (theme) => ({
  popperContainer: {
    // Needed to mimic the design
    paddingTop: theme.spacing(2),
    '& > *': {
      boxShadow: '0 9px 46px 8px rgba(0, 0, 0, 0.14), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 11px 15px -7px rgba(0, 0, 0, 0.20)',
    },
  },
}));

export function FilterControl({
  label, open, setOpen, children,
}) {
  const btnRef = useRef();
  const classes = useStyles();
  return (
    <>
      <FDSecondaryActionButton
        label={label}
        icon="keyboardArrowDown"
        iconPosition="end"
        ref={btnRef}
        onClick={() => (open ? setOpen(false) : setOpen(true))}
      />
      <Popper
        open={open}
        anchorEl={btnRef.current}
      >
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <div className={classes.popperContainer}>
            <FDPaper color="subtle" appearance="flat">
              <FDStack direction={'column'} spacing={2} minWidth={250}>
                {children}
              </FDStack>
            </FDPaper>
          </div>
        </ClickAwayListener>
      </Popper>
    </>
  );
}
